import { z } from 'zod';

import { withCodeLength } from '../_shared/schema';

/**
 * The code field, and nothing else — the number is already settled and travels
 * in location state rather than in a control the operator could edit here.
 *
 * The schema is **built from the served configuration** rather than declared as
 * a constant: `OTP_CODE_LENGTH` is a setting, and a literal here would compile
 * in a value the catalog does not declare and the console could not follow when
 * it changed. Where the configuration read has not resolved, the unnarrowed
 * shape ships and the server answers.
 */
export function buildVerifySchema(codeLength: number | undefined) {
  return z.object({ code: withCodeLength(codeLength) });
}

export type VerifyFields = { code: string };
export type VerifyValues = z.output<ReturnType<typeof buildVerifySchema>>;
